import { useState,useEffect ,useRef} from "react";
import { FaInfoCircle,FaPlus, FaSync } from "react-icons/fa";
import Pagination from "../components/Pagination";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

export default function Students() {

 const [students, setStudents] = useState([]);

  const [nameSearch, setNameSearch] = useState("");
  //const [studentSaved, setStudentSaved] = useState(false);
  const [admissionFilter, setAdmissionFilter] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
   const [loading, setLoading] = useState(false);
   const hasFetched = useRef(false);

  const handleChange = (e) => {const { name, value } = e.target;
    setSelectedStudent({
      ...selectedStudent,
      [name]: value
    });
  };
  
  useEffect(() => {
    if (hasFetched.current) return;
      hasFetched.current = true;
    loadStudents();
  }, []);

  const loadStudents = async () => {
    try {
       setLoading(true);
      const response = await axiosInstance.get("/students");
      setStudents(response.data);

    } catch (error) {
      console.error("Error loading students", error);
    }finally{
       setLoading(false);
    }
  };
  // Filtering logic
  const filteredStudents = students?students.filter((student) => {
    const matchesName =
      student.firstName.toLowerCase().includes(nameSearch.toLowerCase());

    const matchesAdmissionNo =
         student.admissionNumber.toLowerCase().includes(admissionFilter.toLowerCase());
      //admissionFilter === "" || student.admissionNumber === admissionFilter;

    return matchesName && matchesAdmissionNo;
  }):[];

   const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentStudents = filteredStudents?filteredStudents.slice(indexOfFirst, indexOfLast):[];

   const retrieveStudent = async (id) => {//Save Logic
      try {
        setLoading(true);
        //const route = selectedUser.id?"/users/updateUser":"/users/register";
        const response = await axiosInstance.get(`/students/${id}`);

        if (response.data.status === "SUCCESS") {
          //alert("Student Saved successfully");
            setSelectedStudent(response.data.data);
          // fetchUsers();
        }else{
            if (response.data.message) {
              alert(response.data.message); 
            } else {
              alert(response.message || "Error in Retrieve Student");
            }
        }
      } catch (errors) {
          alert("Error in Retrieve Student");
      }finally{
        setLoading(false);
      }

    };

   const saveStudent = async () => {//Save Logic
        try {
          setLoading(true);
          const response = await axiosInstance.post("/students/save", selectedStudent);
          if (response.data.status === "SUCCESS") {
            alert("Student Saved successfully");
            setSelectedStudent(null)
           // setStudentSaved(true);
            loadStudents();
          } else {
            if (response.data.errors && response.data.errors.length > 0) {
              alert(response.data.errors.join("\n")); // show all errors
            } else {
              alert(response.message || "Error in Saving user");
            }
          }
        } catch (errors) {
            alert("Error in Saving user");
        }finally{
          setLoading(false);
        }

      };
  return (
    <div>

      {/* Header Section */}
     <div className="flex justify-between items-center mb-2">
        {loading && <Loader />}
        <h2 className="text-2xl font-bold">Students</h2>

        <div className="hidden md:flex gap-3">

          {/* Refresh Button */}
          <button
            onClick={loadStudents}
            className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded flex items-center gap-2"
          >
            🔄 Refresh
          </button>

          {/* New Student Button */}
          <button
            onClick={() => {
              setSelectedStudent({
                firstName: "",
                lastName: "",
                email: "",
                address: "",
                penNo: "",
                admissionNumber: "",
                admissionDate:new Date().toLocaleString(),
                gender:"",
                motherName:"",
                parentName:"",
                motherPhone:"",
                parentPhone:"",
                bloodGroup:"",
                notes:"",
                isActive:"Yes"
              });
             // setShowModal(true);
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            + New
          </button>
        </div>
        <div className="flex md:hidden gap-3 text-xl">

          <button 
          onClick={loadStudents}
          className="p-2 bg-gray-200 rounded-full">
            <FaSync />
          </button>
          <button  onClick={() => {
              setSelectedStudent({
                firstName: "",
                lastName: "",
                email: "",
                address: "",
                admissionNumber: "",
                penNo: "",
                admissionDate:new Date().toLocaleString(),
                gender:"",
                motherName:"",
                parentName:"",
                motherPhone:"",
                parentPhone:"",
                bloodGroup:"",
                notes:"",
                isActive:"Yes"
              });
             // setShowModal(true);
            }}
            className="p-2 bg-blue-600 text-white rounded-full">
            <FaPlus />
          </button>
        </div>
      </div>
      {loading && <Loader />}
      {/* Filters Section */}
      <div className="flex flex-col md:flex-row gap-4 mb-2">

        {/* Name Search */}
        <input
          type="text"
          autoComplete="off"
          placeholder="Search by Name..."
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={nameSearch}
          onChange={(e) => {
            setNameSearch(e.target.value);
            setCurrentPage(1);
            }}
        />

        {/* Admission Search */}
        <input
          type="text"
          placeholder="Search by Admission No..."
          autoComplete="off"
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={admissionFilter}
          onChange={(e) => {
            setAdmissionFilter(e.target.value);
            setCurrentPage(1);
            }}
        />

        {/* Class Dropdown */}
        {/* <select
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={admissionFilter}
          onChange={(e) => {
            setAdmissionFilter(e.target.value);
            setCurrentPage(1);
            }}
        >
          <option value="">All Classes</option>
          {uniqueClasses.map((cls, index) => (
            <option key={index} value={cls}>
              {cls}
            </option>
          ))}
        </select> */}

      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-x-auto">
        <Pagination
        totalItems={filteredStudents.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setItemsPerPage={setItemsPerPage}
        />
        <table className="w-full text-left">
          <thead className="bg-gray-100 text-gray-600" >
            <tr>
              <th className="p-4">Name</th>
              <th className="p-4">Admission No</th>
              <th className="p-4">Email</th>
              <th className="p-4">Gender</th>
              <th className="p-4">PEN No</th>
              {/* <th className="p-4">Parent PhNo</th> */}
              <th className="p-4">Active</th>
            </tr>
          </thead>

          <tbody>
            {filteredStudents.length > 0 ? (
             currentStudents.map((student) => (
                <tr
                  key={student.id}
                  className="border-t hover:bg-gray-50 transition"
                >
                  <td className="p-4">
                    <div className="flex items-center gap-2">
                       {student.firstName} {student.lastName}
                        <button  onClick={() => retrieveStudent(student.id)}
                            className="text-gray-500 hover:text-blue-600" >
                        <FaInfoCircle size={14} />
                        </button>
                    </div>
                  </td>
                  <td className="p-4">{student.admissionNumber}</td>
                  <td className="p-4">{student.email}</td>
                  <td className="p-4">{student.gender}</td>
                  <td className="p-4">{student.penNo}</td>
                  {/* <td className="p-4">{student.parentPhone}</td> */}
                  <td className="p-4">{student.isActive}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">
                  No students found
                </td>
              </tr>
            )}
          </tbody>

        </table>
       
        {selectedStudent && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
               {loading && <Loader />}
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl p-6 relative">

              {/* Close */}
              <button
                onClick={() => setSelectedStudent(null)}
                className="absolute top-3 right-3 text-gray-500 hover:text-black"
              >
                ✕
              </button>

              {/* Profile Header */}
              <div className="flex items-center gap-4 mb-6 border-b pb-4">
                <img
                  src={selectedStudent.photo || "/default-student.png"}
                  alt="profile"
                  className="w-20 h-20 rounded-full object-cover border"
                />
              </div>

              {/* Student Details */}
              <h4 className="text-lg text-blue-600 font-semibold mb-3">Student Details</h4>

              <div className="grid grid-cols-3 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm mb-6">

                <div>
                  <label className="font-medium">First Name</label>
                  <input
                    type="text" name="firstName" onChange={handleChange}
                    value={selectedStudent.firstName || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Last Name</label>
                  <input
                    type="text" name="lastName" onChange={handleChange}
                    value={selectedStudent.lastName || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Admission No</label>
                  <input
                    type="text" name="admissionNumber" onChange={handleChange}
                    value={selectedStudent.admissionNumber || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
                <div>
                  <label className="font-medium">Admission Date</label>
                  <input
                    type="date" name="admissionDate" onChange={handleChange}
                    value={selectedStudent.admissionDate || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">PEN No</label>
                  <input
                    type="text" name="penNo" onChange={handleChange}
                    value={selectedStudent.penNo || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                {/* <div>
                  <label className="font-medium">Class</label>
                  <select
                    value={selectedStudent.classId || ""}
                    onChange={(e) =>
                      setSelectedStudent({
                        ...selectedStudent,
                        classId: e.target.value
                      })
                    }
                    className="w-full border rounded px-2 py-1"
                  >
                    <option value="">Select Class</option>
                    {uniqueClasses.map((cls, index) => (
                      <option key={index} value={index}>
                        {cls}
                      </option>
                    ))}
                  </select>
                </div> */}

                <div>
                  <label className="font-medium">Father Name</label>
                  <input
                    type="text" name="parentName" onChange={handleChange}
                    value={selectedStudent.parentName || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Father Phone</label>
                  <input
                    type="text" name="parentPhone" onChange={handleChange}
                    value={selectedStudent.parentPhone || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Mother Name</label>
                  <input
                    type="text" name="motherName" onChange={handleChange}
                    value={selectedStudent.motherName || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Mother Phone</label>
                  <input
                    type="text" name="motherPhone" onChange={handleChange}
                    value={selectedStudent.motherPhone || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Email</label>
                  <input
                    type="text" name="email" onChange={handleChange}
                    value={selectedStudent.email || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Blood Group</label>
                  <input
                    type="text" name="bloodGroup" onChange={handleChange}
                    value={selectedStudent.bloodGroup || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>

                <div>
                  <label className="font-medium">Gender</label>
                  <select
                    value={selectedStudent.gender || ""}
                    name="gender" onChange={handleChange}
                    className="w-full border rounded px-2 py-1"
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div>
                  <label className="font-medium">Active</label>
                  <select
                    value={selectedStudent.isActive}
                    name="isActive" onChange={handleChange}
                    className="w-full border rounded px-2 py-1"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                {/* <div>
                  <p className="font-medium">Pending Fee</p>
                  <span className="inline-block mt-1 px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-semibold">
                    {selectedStudent.pendingFee}
                  </span>
                </div> */}

                {/* Address full row */}
                <div className="col-span-3">
                  <label className="font-medium">Address</label>
                  <textarea
                    value={selectedStudent.address || ""}
                    name="address" onChange={handleChange}
                    className="w-full border rounded px-2 py-1"
                    rows="2"
                  />
                </div>

              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setSelectedStudent(null)}
                  className="px-4 py-2 bg-gray-200 rounded"
                >
                  Cancel
                </button>

                <button onClick={() => saveStudent(selectedStudent)}
                 className="px-4 py-2 bg-blue-600 text-white rounded">
                  Save
                </button>
              </div>

            </div>
          </div>
        )}
      </div>

    </div>
  );
}